import { Component, input } from '@angular/core';
import { SbSupportTextBlockComponent } from '@app/+modals/sb-support/blocks/text/sb-support-text-block.component';
import { TranslatePipe } from '@ngx-translate/core';
import { clsx } from 'clsx';

@Component({
  selector: 'sb-support-contact-widget',
  templateUrl: './sb-support-contact-widget.component.html',
  imports: [SbSupportTextBlockComponent, TranslatePipe],
  host: {
    '[class]': 'hostClass',
  },
})
export class SbSupportContactWidgetComponent {
  hostClass = clsx('flex flex-col gap-sm');

  supportEmail = input.required<string>();
  supportPhone = input.required<string>();
}
